import React from "react";

const LabelAndValue = ({ label = "", value = "", shouldCapitalize = true }) => {
  return (
    <div className="flex-1 font-poppins">
      <p
        className="font-medium text-sm"
        style={{
          textTransform: shouldCapitalize ? "capitalize" : undefined,
        }}
      >
        {value || "--"}
      </p>

      <p className="mt-1 font-normal text-xs text-dark-gray">{label}</p>
    </div>
  );
};

export default LabelAndValue;
